import createReactComponent from '../createReactComponent';
export default createReactComponent('rating-14-plus', 'IconRating14Plus', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M7 15v-6', key: 'svg-1' }],
  ['path', { d: 'M15.5 12h3', key: 'svg-2' }],
  ['path', { d: 'M17 10.5v3', key: 'svg-3' }],
  ['path', { d: 'M12.5 15v-6m-2.5 0v4h3', key: 'svg-4' }],
]);
